// extracted by mini-css-extract-plugin
module.exports = {"search_input":"style_search_input__DrwWN","inputBox":"style_inputBox__dFWZk","search_label":"style_search_label__YAiVN","close":"style_close__kDPbH"};